import { useState, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import Breadcrumbs from "examples/Breadcrumbs";
import SoftButton from "components/SoftButton";

import {
	navbar,
	navbarContainer,
	navbarRow,
	navbarIconButton,
	navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";
import {
	useSoftUIController,
	setTransparentNavbar,
	setMiniSidenav,
} from "context";
import ApnaSelect from "components/ApnaSelect/location";
import { getLocationData } from "api/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { setFilterLocation } from "api/searchSlice";
import { getSearch } from "api/searchSlice";
import ActionMenu from "admin/components/atoms/ActionButton";
import { ChangeThemeOnRedux } from "api/commonSlice";
import { Switch } from "@mui/material";
import { styled } from '@mui/material/styles';
import SoftBoxRoot from "components/SoftBox/SoftBoxRoot";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LightModeIcon from '@mui/icons-material/LightMode';
import NightlightIcon from '@mui/icons-material/Nightlight';
import borders from "assets/theme/base/borders";

function DashboardNavbar({ absolute, light, isMini }) {
	const navigate = useNavigate()

	const pathname = useLocation().pathname;
	const [navbarType, setNavbarType] = useState();
	const [controller, dispatch] = useSoftUIController();
	const { miniSidenav, transparentNavbar, fixedNavbar } = controller;
	const route = useLocation().pathname.split("/").slice(1);
	const isToken = localStorage.getItem("token");
	const isScope = localStorage.getItem("scope");
	const dispatcho = useDispatch();
	const locations = useSelector((state) => state.commonSlice?.locations);
	const [allLocations, setAllLocations] = useState([]);
	const userTheme = useSelector((state) => state.commonSlice.theme);
	const [theme, setTheme] = useState(localStorage.getItem('theme'));
	useEffect(() => {
		if (pathname == "/dashboard" || pathname == "/couponReports") {
			dispatcho(getLocationData());
		}
	}, []);

	useEffect(() => {
		if (locations) {
			setAllLocations([]);
			locations &&
				locations.length > 0 &&
				locations.map((location) => {
					setAllLocations((prev) => [...prev, { _id: location?._id, name: location?.locationName }]);
				})
		}
	}, [locations])

	const onChangeLocation = (e) => {
		dispatcho(setFilterLocation(e.target.value));
	}

	useEffect(() => {
		// Setting the navbar type
		if (fixedNavbar) {
			setNavbarType("sticky");
		} else {
			setNavbarType("static");
		}
		// A function that sets the transparent state of the navbar.
		function handleTransparentNavbar() {
			setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
		}

		window.addEventListener("scroll", handleTransparentNavbar);

		handleTransparentNavbar();
		return () => window.removeEventListener("scroll", handleTransparentNavbar);
	}, [dispatch, fixedNavbar]);

	const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);

	const onSearchChange = (e) => {
		dispatcho(getSearch(e.target.value));
	}

	const ChangeToLightMode = () => {
		const theme = localStorage.getItem('theme');
		const userScope = localStorage.getItem('scope');
		// Update the theme in localStorage and apply styles
		if (theme === 'dark') {
			setTheme('light');
			dispatcho(ChangeThemeOnRedux('light'))
			localStorage.setItem('theme', 'light');
			document.body.classList.add('light-mode');
			document.body.classList.remove('dark-mode');
		} else {
			setTheme('dark');
			dispatcho(ChangeThemeOnRedux('dark'))
			localStorage.setItem('theme', 'dark');
			document.body.classList.add('dark-mode');
			document.body.classList.remove('light-mode');
		}
	};

	const backgroundStyle = {
		padding: "2px",
		borderRadius: "5px",
		color: 'light',
		borders: '1px solid',
		background: theme === 'dark'
			? '#282828'
			: '#e0e0e0'
	};
	const handleLogout = () => {
		localStorage.removeItem("token");
		localStorage.removeItem("id");
		localStorage.clear()
		window.location.href = "/login";
	};
	const backToAdmin = () => {

		localStorage.setItem('scope', '1')
		localStorage.setItem('id', localStorage.getItem('tempid'))
		localStorage.setItem('token', localStorage.getItem('temptoken'))
		localStorage.setItem('info', localStorage.getItem('tempinfo'))
		localStorage.setItem('rememberMeEmail', localStorage.getItem('temprememberMeEmail'))
		localStorage.setItem('rememberMePassword', localStorage.getItem('temprememberMePassword'))
		localStorage.setItem('clickedItem', 'business-users')
		// navigate('/')
		localStorage.removeItem('tempscope')
		localStorage.removeItem('tempid')
		// localStorage.removeItem('temprememberMeEmail')
		// localStorage.removeItem('temprememberMePassword')
		localStorage.removeItem('temptoken')
		localStorage.removeItem('tempinfo')

		// window.location.reload();
		window.location.href = '/admin/business-users';
	}

	const ToggleContainer = styled(Box)(({ theme }) => ({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
	}));
	const SwitchBox = styled(Box)(({ theme }) => ({
		display: 'flex',
		backgroundColor: '#e0e0e0',
		borderRadius: '10px',
		padding: '4px',
	}));

	const SwitchOption = styled(Box)(({ selected }) => ({
		width: 38,
		height: 38,
		backgroundColor: selected ? '#0F0E12' : 'transparent',
		borderRadius: '8px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		cursor: 'pointer',
		transition: 'background-color 0.3s ease',
	}));
	const isDark = theme === 'dark';

	return (

		<AppBar
			position={absolute ? "absolute" : navbarType}
			color="inherit"
			sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
		>
			<Toolbar sx={(theme) => navbarContainer(theme)}>
				<SoftBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
					<Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} />
				</SoftBox>

				{isMini ? null : (
					<SoftBox sx={(theme) => navbarRow(theme, { isMini })}>
						{localStorage.getItem('tempinfo') && (
							<SoftBox mr={2}>
								<SoftButton
									onClick={() => backToAdmin()}
									variant="gradient" color="info" fullWidth>
									Back to admin
								</SoftButton>

							</SoftBox>)
						}

						<SoftBox mr={2}>
							{
								(pathname == '/dashboard' || pathname == "/couponReports") && locations &&
								locations.length > 0 &&
								<ApnaSelect
									origin="location"
									options={allLocations}
									onChange={onChangeLocation}
								/>
							}
						</SoftBox>

						{/* <SoftBox mr={2}>
							<ToggleContainer>
								<SwitchBox>
									<SwitchOption
										selected={!isDark}
										onClick={() => ChangeToLightMode(false)}
									>
										<LightModeIcon sx={{ color: !isDark ? 'white' : '#888' }} />
									</SwitchOption>

									<SwitchOption
										selected={isDark}
										onClick={() => ChangeToLightMode(true)}
									>
										<NightlightIcon sx={{ color: isDark ? 'white' : '#888' }} />
									</SwitchOption>
								</SwitchBox>
							</ToggleContainer>
						</SoftBox> */}


						<SoftBox color={light ? "white" : "inherit"}>
							<div style={backgroundStyle}>

								<ActionMenu
									items={[
										{ label: 'Profile', onClick: () => { navigate(`/profile`) } },
										{ label: 'Logout', onClick: () => { handleLogout() } },
									]}
								/>
							</div>
							<IconButton
								size="small"
								color="inherit"
								sx={navbarMobileMenu}
								onClick={handleMiniSidenav}
							>
								<Icon className={light ? "text-white" : "text-dark"}>
									{miniSidenav ? "menu_open" : "menu"}
								</Icon>
							</IconButton>

						</SoftBox>
					</SoftBox>
				)}
			</Toolbar>
		</AppBar>
	);
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
	absolute: false,
	light: false,
	isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
	absolute: PropTypes.bool,
	light: PropTypes.bool,
	isMini: PropTypes.bool,
};

export default DashboardNavbar;
